export default {
  addSchoolAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addSchool", payload)
      resolve()
    })
  }
}
